module.exports = __webpack_public_path__ + "img/cart.74b02e23.svg";